import { supabase } from '../Supabase/SupabaseClient';

export const SITE_BUCKET = 'fotos';
export const SITE_PREFIX = 'sitio';

/* Fallback local por si el slot todavia no tiene foto subida en Supabase. */
export const FALLBACK_HERO = '/images/hero.png';

const CARRUSEL_ALTS = [
  'Portfolio guitarra',
  'Portfolio trece',
  'Portfolio jp',
  'Portfolio rosa',
  'Portfolio carting',
  'Portfolio ramo',
  'Portfolio chica y caballo',
  'Portfolio boina',
  'Portfolio familia',
  'Portfolio faro',
  'Portfolio montaña',
  'Portfolio caballo',
  'Portfolio silla',
  'Portfolio reja',
  'Portfolio lu',
];

const CATEGORIAS_METRO = [
  { clave: 'categoria.eventos', titulo: 'Eventos' },
  { clave: 'categoria.sesiones', titulo: 'Sesiones' },
  { clave: 'categoria.estudio', titulo: 'Alquiler de estudio' },
  { clave: 'categoria.efectos', titulo: 'Efectos especiales' },
  { clave: 'categoria.adicionales', titulo: 'Servicios adicionales' },
  { clave: 'categoria.otros', titulo: 'Otros servicios' },
];

export const GRUPOS = [
  {
    id: 'home',
    titulo: 'Home',
    descripcion: 'La foto principal del hero y la credencial "¡Hola! Soy Sole Costilla".',
    slots: [
      { clave: 'hero.main', etiqueta: 'Foto principal del hero', alt: 'Foto principal' },
      { clave: 'hero.sole', etiqueta: 'Hola, soy Sole Costilla', alt: 'Foto de Sole Costilla' },
    ],
  },
  {
    id: 'polaroid',
    titulo: 'Polaroids',
    descripcion: 'Las tres fotos inclinadas de la galería polaroid. Se omiten si quedan vacías.',
    slots: [
      { clave: 'polaroid.1', etiqueta: 'Polaroid 1', alt: 'Sesión en avioneta' },
      { clave: 'polaroid.2', etiqueta: 'Polaroid 2', alt: 'Sesión de quince en la nieve' },
      { clave: 'polaroid.3', etiqueta: 'Polaroid 3', alt: 'Detalle de auriculares' },
    ],
  },
  {
    id: 'carrusel',
    titulo: 'Carrusel',
    descripcion: 'Las quince fotos del carrusel de portfolio, en el orden en que se muestran.',
    slots: CARRUSEL_ALTS.map((alt, i) => ({
      clave: `carrusel.${i + 1}`,
      etiqueta: `Carrusel ${i + 1}`,
      alt,
    })),
  },
  {
    id: 'categoria',
    titulo: 'Categorías de servicios',
    descripcion: 'La foto de cada tarjeta del acordeón de servicios.',
    slots: CATEGORIAS_METRO.map((cat) => ({
      clave: cat.clave,
      etiqueta: cat.titulo,
      alt: cat.titulo,
      categoriaId: cat.clave.replace('categoria.', ''),
    })),
  },
];

/* Mapa clave -> slot para buscar rapido desde los componentes del sitio. */
export const SLOTS_POR_CLAVE = GRUPOS.flatMap((grupo) =>
  grupo.slots.map((slot, i) => ({ ...slot, grupo: grupo.id, orden: i }))
);

/* Cuantas imagenes espera cada grupo como minimo para no mostrar huecos. */
export const MINIMO_POR_GRUPO = { polaroid: 3, carrusel: 15 };

export function construirRuta(clave, fileName) {
  return `${SITE_PREFIX}/${clave}/${fileName}`;
}

/**
 * Traduce la respuesta de site_assets a un mapa { [clave]: { url, path, alt } }.
 * Ignora los slots sin url para que el sitio caiga a su fallback local.
 */
export function mapearAssets(rows) {
  const mapa = {};
  (rows || []).forEach((row) => {
    if (!row?.clave || !row?.url_foto) return;
    mapa[row.clave] = {
      url: row.url_foto,
      path: row.path || null,
      alt: row.alt || '',
    };
  });
  return mapa;
}

export async function cargarSiteAssets() {
  const { data, error } = await supabase
    .from('site_assets')
    .select('clave, alt, url_foto, path, orden')
    .order('orden', { ascending: true });

  if (error) throw error;
  return mapearAssets(data);
}
